module.exports = __webpack_public_path__ + "static/media/hodlnaut.41f32fc5.svg";